import React from 'react'

const ProjectOverview = () => {
  return (
    <div>
        <img src="paymentPlan1.png" height='100%' width='100%'></img>
        <img src="paymentPlan2.png" height='100%' width='100%'></img>
        <img src="paymentPlan3.png" height='100%' width='100%'></img>
    </div>
  )
}

export default ProjectOverview